import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const Edit = () => {
    const { rut } = useParams();
    const [formData, setFormData] = useState(null);
    const navigate = useNavigate();
    const [zonas, setZonas] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [tipo_socio, setTipoSocios] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [diocesis, setDiocesis] = useState([]);
    const [familias, setFamilias] = useState([]);

    const [editField, setEditField] = useState(null); // Campo en modo edición

    const fieldLabels = {
        n_socio: "N° Socio",
        rut: "RUT",
        nombre: "Nombres",
        apellido: "Apellidos",
        telefono: "Teléfono",
        email: "Correo Electrónico",
        tipo_socio: "Tipo de Socio",
        zona: "Zona",
        region: "Región",
        comuna: "Comuna",
        direccion: "Dirección",
        fecha_nacimiento: "Fecha de Nacimiento",
        fecha_inicio_socio: "Fecha de Inicio como Socio",
        fecha_oficializacion: "Fecha de Oficialización",
        oficio: "Oficio",
        status: "Estado",
        notas: "Notas",
        diocesis: "Diocesis",
        familia: "Familia"
    };

    // Convertir fecha al formato dd-mm-aaaa
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Convertir fecha de dd-mm-aaaa a formato ISO (aaaa-mm-dd)
    const parseDate = (dateString) => {
        if (!dateString) return "";
        const [day, month, year] = dateString.split("-");
        return `${year}-${month}-${day}`;
    };

    // Cargar datos del socio
    useEffect(() => {
        if (rut) {
            axios.get(`http://192.168.1.81:5000/backend/api/socios/${rut}`)
                .then(response => {
                    const data = response.data;
                    // Formatear fechas al cargar los datos
                    data.fecha_nacimiento = formatDate(data.fecha_nacimiento);
                    data.fecha_inicio_socio = formatDate(data.fecha_inicio_socio);
                    data.fecha_oficializacion = formatDate(data.fecha_oficializacion);
                    setFormData(data);
                })
                .catch(error => {
                    alert("Socio no encontrado");
                    console.error("Error al buscar socio", error);
                    navigate("/mostrar");
                });
        }
    }, [rut, navigate]);

    // Cargar listas desplegables
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [zonasRes, tiposRes, statusRes] = await Promise.all([
                    axios.get("http://192.168.1.81:5000/backend/api/zonas"),
                    axios.get("http://192.168.1.81:5000/backend/api/tipos"),
                    axios.get("http://192.168.1.81:5000/backend/api/status")
                ]);
                setZonas(zonasRes.data);
                setTipoSocios(tiposRes.data);
                setStatusList(statusRes.data);
            } catch (error) {
                console.error("Error al obtener datos iniciales", error);
            }
        };
        fetchData();
    }, []);

    // Cargar regiones según la zona seleccionada
    useEffect(() => {
        if (!formData?.zona) return;
        axios.get(`http://192.168.1.81:5000/backend/api/regiones?zona=${formData.zona}`)
            .then(response => setRegiones(response.data))
            .catch(error => console.error("Error al obtener regiones", error));
    }, [formData?.zona]);

    // Cargar comunas según la región seleccionada
    useEffect(() => {
        if (!formData?.region) return;
        axios.get(`http://192.168.1.81:5000/backend/api/comunas?region=${formData.region}`)
            .then(response => setComunas(response.data))
            .catch(error => console.error("Error al obtener comunas", error));
    }, [formData?.region]);

    useEffect(() => {
        if (!formData?.zona) return;
        axios.get(`http://192.168.1.81:5000/backend/api/diocesis?zona=${formData.zona}`)
            .then(response => setDiocesis(response.data))
            .catch(error => console.error("Error al obtener diocesis", error));
    }, [formData?.zona]);

    // Cargar comunas según la región seleccionada
    useEffect(() => {
        if (!formData?.diocesis) return;
        axios.get(`http://192.168.1.81:5000/backend/api/familias?diocesis=${formData.diocesis}`)
            .then(response => setFamilias(response.data))
            .catch(error => console.error("Error al obtener familias", error));
    }, [formData?.diocesis]);

    // Manejar cambios en los campos
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    // Manejar clic en un campo para habilitar la edición
    const handleFieldClick = (fieldName) => {
        setEditField(fieldName);
    };

    // Manejar envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const dataToSend = { ...formData };
            // Convertir fechas al formato ISO antes de enviar
            dataToSend.fecha_nacimiento = parseDate(dataToSend.fecha_nacimiento);
            dataToSend.fecha_inicio_socio = parseDate(dataToSend.fecha_inicio_socio);
            dataToSend.fecha_oficializacion = parseDate(dataToSend.fecha_oficializacion);

            await axios.post(`http://192.168.1.81:5000/backend/api/socios/${rut}`, dataToSend);
            alert("Socio actualizado con éxito");
            navigate("/mostrar");
        } catch (error) {
            alert("Error al actualizar socio");
            console.error("Error al actualizar socio", error);
        }
    };

    if (!formData) {
        return <div className="container mt-5 text-center">Cargando datos...</div>;
    }

    return (
        <div className="container mt-5">
            <div className="card shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-center mb-4">Editar Socio</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            {Object.keys(formData).map((key) => (
                                <div key={key} className="col-md-6">
                                    <label className="form-label">
                                        {fieldLabels[key] || key}
                                    </label>
                                    {["tipo_socio", "zona", "region", "comuna", "status", "diocesis", "familia"].includes(key) ? (
                                        <select
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            className="form-select"
                                            required
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {(key === "tipo_socio" ? tipo_socio : key === "zona" ? zonas : key === "region" ? regiones : key === "comuna" ? comunas : key === "diocesis" ? diocesis : key === "familia" ? familias :
                                                statusList).map(item => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.nombre}
                                                    </option>
                                                ))}
                                        </select>
                                    ) : (
                                        <input
                                            type={key.includes("fecha") ? "text" : "text"} // "text" para fechas formateadas
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={editField !== key || key === "n_socio" || key === "rut"} // Deshabilitar edición
                                            disabled={key === "n_socio" || key === "rut"}
                                            onClick={() => handleFieldClick(key)}
                                            required
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-success w-100 mt-3">Actualizar</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Edit;